// Enhanced function to detect feedback responses by their unique markdown headers
export const isFeedbackAnalysis = (text: string): boolean => {
  const feedbackMarkers = [
    '## 📊', '## ✅', '## ❌', '## 🔄', '## 💡',
    'Impressions Overview', 'Accurate Impressions', 'Analysis of User Notes',
    'Accurate Elements', 'Inaccurate Elements', 'Partial Matches', 'Target Details'
  ];
  return feedbackMarkers.some(marker => text.includes(marker));
};